import { LicenseCode, LicensePaymentStatus } from "Infrastructure/Api/Api";
import { z } from "zod";

export const schema = z.object({
  paymentStatus: z.enum(LicensePaymentStatus),
  paymentDate: z.string().nullish(),
  licenseNo: z.string().nullish(),
  code: z.enum(LicenseCode),
  walletAddress: z.string().nullish(),
});

export type LicenseFormData = z.infer<typeof schema>;
